import { Button } from "@mantine/core";
import { useTranslation } from "react-i18next";

interface ActionButtonsProps {
  isPending: boolean;
  showSaveButton?: boolean;
  saveDisabled?: boolean;
  saveButtonLabel?: string;
  onClickCancel: () => void;
  onClickConfirm?: () => void;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
  isPending,
  showSaveButton = true,
  saveDisabled = false,
  saveButtonLabel,
  onClickCancel,
  onClickConfirm,
}) => {
  const { t } = useTranslation("common");
  return (
    <>
      <Button
        data-testid="cancel-btn"
        radius={8}
        color="gray"
        variant="outline"
        onClick={onClickCancel}
        ml={"sm"}
        type="button"
        tt={"uppercase"}
        loading={isPending}
      >
        {t("cancel")}
      </Button>
      {showSaveButton && (
        <Button
          radius={8}
          variant="filled"
          onClick={onClickConfirm}
          bg={saveDisabled ? "gray" : "green"}
          c={saveDisabled ? "white" : undefined}
          disabled={saveDisabled}
          data-testid="confirm-btn"
          loading={isPending}
          mr={"sm"}
          type="submit"
          tt={"uppercase"}
        >
          {saveButtonLabel ?? t("save")}
        </Button>
      )}
    </>
  );
};

export default ActionButtons;
